export const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 1120,
  lg: 1440,
  xl: 1920,
  max: 2100, // we will use it to spacial element that break the container
};
